import React from 'react';
import { Hero, SocialProof, TestimonialsHero } from './components/Hero';
import { PainPoints, ProductIntro } from './components/PainPoints';
import { TomosGrid, BonusesGrid } from './components/ProductDetails';
import { PricingSection, EliteSection, ComparisonTable } from './components/Pricing';
import { TestimonialsExtended, Guarantee, FAQ, Footer } from './components/FooterSections';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream text-stone-900 font-sans selection:bg-coral-500/30 selection:text-coral-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <TestimonialsHero data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductIntro data-id="element-6" />
      <TomosGrid data-id="element-7" />
      <BonusesGrid data-id="element-8" />
      <PricingSection data-id="element-9" />
      <EliteSection data-id="element-10" />
      <ComparisonTable data-id="element-11" />
      <TestimonialsExtended data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <Footer data-id="element-15" />

      <PurchasePopup data-id="element-16" />
    </div>;
}